  
const initialState = {
  data: [],
  selected: null, 
  loading: false,
  saving: false,
  error: null,
  editingEvidence: null,
  loadingEditingEvidence: false,
};

const DocumentReducer = (state = initialState, action) => {
  switch (action.type) {

    case 'LOAD_EVIDENCES_REQUEST':
      return { ...state, loading: true, error: null,};
    case 'LOAD_EVIDENCES_SUCCESS':
      return { ...state, loading: false, data: action.payload, error: null};
    case 'LOAD_EVIDENCES_FAIL':
      return { ...state, loading: false, error: action.payload,};
    
    case 'SAVE_EVIDENCES_REQUEST':
      return{ ...state, saving: true,};
    case 'SAVE_EVIDENCES_SUCCESS':
      return{ ...state, saving: false};
    case 'SAVE_EVIDENCES_FAIL':
      return{ ...state, saving: false, error: action.payload};

    case 'DELETE_EVIDENCES_REQUEST':
      return{ ...state, loading: true,};
    case "DELETE_EVIDENCES_SUCCESS":
      return {
        ...state,
        data: state.data.filter(ev => ev.Id !== action.payload)
      }
    case 'DELETE_EVIDENCES_FAIL':
      return{ ...state, loading: false, error: action.payload };

    case 'LOAD_EVIDENCE_BY_ID_REQUEST':
      return { ...state, loadingEditingEvidence: true, error: null };
    case 'LOAD_EVIDENCE_BY_ID_SUCCESS':
      return { ...state, loadingEditingEvidence: false, editingEvidence: action.payload, error: null };
    case 'LOAD_EVIDENCE_BY_ID_FAIL':
      return { ...state, loadingEditingEvidence: false, error: action.payload };
    case 'PROCESS_CHANGED_CLEAR_STATE':
    case 'PERMISSION_CHANGED_CLEAR_STATE':
      return { ...initialState };

    default:
      return state;
  }
};

export default DocumentReducer;
    